import React, { Fragment } from 'react'
import cs_1 from '../../images/Review1.webp'
import cs_2 from '../../images/Review2.webp'
import cs_3 from '../../images/Review3.webp'
import { Link } from 'react-router-dom'
export const Reviews = () => {
    return (
        <Fragment>
            <div className='containerComentarios '>
                <div className='container'>
                    <div className='containerReviews'>
                        <div className='containerInfoContact'>
                            <h2>CONTACTATE <br /> CON  NOSOTROS</h2>
                            <div className='data'>
                                <p><i className="bi bi-headset"></i> (305)-491-2288</p>
                                <p><i className="bi bi-envelope-check-fill"></i> int.drivingacademy@gmail.com</p>
                                <p><i className="bi bi-geo-fill"></i> Florida</p>
                            </div>
                            <div className='links'>
                                <a href="https://www.facebook.com/profile.php?id=61554980072645" target="_blank" rel="noopener noreferrer" aria-label='Facebook'><i className="bi bi-facebook"></i></a>
                                <a href="https://www.instagram.com/int.drivingacademy/" target="_blank" rel="noopener noreferrer" aria-label='Instagram'><i className="bi bi-instagram"></i></a>
                                <a href="https://wa.me/13054912288" target="_blank" rel="noopener noreferrer" aria-label='Whatsapp'><i className="bi bi-whatsapp"></i></a>
                                <a href="https://www.tiktok.com/@int.drivingacademy" target="_blank" rel="noopener noreferrer" aria-label='Tiktok'><i className="bi bi-tiktok"></i></a>
                            </div>
                        </div>
                        <div className='containerReview'>
                            <div className='card'>
                                <img src={cs_1} alt="imagenCliente" effect='blur' loading='lazy' />
                                <div className='cardContentReview'>
                                    <span><i className="bi bi-chat-quote-fill"></i></span>
                                    <div className='cardDetails'>
                                        <p>Super recomendados , excelente servicio , acompañamiento en todo el proceso 10/10</p>
                                        <span>-Cliente Satisfecho</span>
                                    </div>
                                </div>
                            </div>
                            <div className='card'>
                                <img src={cs_2} alt="imagenCliente" effect='blur' loading='lazy' />
                                <div className='cardContentReview'>
                                    <span><i className="bi bi-chat-quote-fill"></i></span>
                                    <div className='cardDetails'>
                                        <p>Nicoll realizo un trabajo excelente con mi hija , tanto en las clases de conduccion,  como en el proceso de la licencia !</p>
                                        <span>-Cliente Satisfecho</span>
                                    </div>
                                </div>
                            </div>
                            <div className='card'>
                                <img src={cs_3} alt="imagenCliente" effect='blur' loading='lazy' />
                                <div className='cardContentReview'>
                                    <span><i className="bi bi-chat-quote-fill"></i></span>
                                    <div className='cardDetails'>
                                        <p>I highly recommend this company, I was looking a way to do my driving test and with them was easy and fast.</p>
                                        <span>-Cliente Satisfecho</span>
                                    </div>
                                </div>
                            </div>
                            <Link to="/comentarios"  aria-label='VER MAS REVIEWS'><button>Ver Mas Reviews</button></Link>
                        </div>
                    </div>
                </div>

            </div>
        </Fragment>
    )
}
export default Reviews;